import moment from "moment";

const CLEAR_USER = "CLEAR_USER";

const ADD_MAIN_DATA = "ADD_MAIN_DATA";
const ADD_CONTRACTS = "ADD_CONTRACTS";
const UPDATE_CONTRACT_BALANCE = "UPDATE_CONTRACT_BALANCE";
const SET_CONTRACT_BALANCE = "SET_CONTRACT_BALANCE";
const ADD_PH_ADR = "ADD_PH_ADR";
const ADD_BILLS = "ADD_BILLS";
const ADD_BENFICIARIES = "ADD_BENFICIARIES";

const CLEAR_CONTRACTS = "CLEAR_CONTRACTS";
const CLEAR_BENFICIARIES = "CLEAR_BENFICIARIES";
const CLEAR_BILLS = "CLEAR_BILLS";
const UPDATE_EXPIRE_SESSION = "UPDATE_EXPIRE_SESSION";
const UPDATE_EMAIL_USER = "UPDATE_EMAIL_USER";
const ADD_P_PH = "ADD_P_PH";
const ADD_C_PH = "ADD_C_PH";
const ADD_P_EM = "ADD_P_EM";

export {
  CLEAR_USER,
  ADD_MAIN_DATA,
  ADD_CONTRACTS,
  UPDATE_CONTRACT_BALANCE,
  ADD_PH_ADR,
  ADD_BILLS,
  ADD_BENFICIARIES,
  CLEAR_CONTRACTS,
  CLEAR_BENFICIARIES,
  CLEAR_BILLS,
  UPDATE_EXPIRE_SESSION,
  SET_CONTRACT_BALANCE,
  UPDATE_EMAIL_USER,
  ADD_P_PH,
  ADD_C_PH,
  ADD_P_EM
};

function addMainData(data) {
  const dateTime = moment(new Date()).add(1770, 's').toDate().getTime();
  return {
    type: ADD_MAIN_DATA,
    user: {
      name: data.names,
      lastName: data.lastName,
      docType: data.docType,
      docNumber: data.docNumber,
      email: data.email,
      age: data.age,
      expireSession: dateTime
    }
  };
}

function addContracts(data) {
  return {
    type: ADD_CONTRACTS,
    user: {
      contracts: data.contracts
    }
  };
}

function updateContractsBalance(data) {
  return {
    type: UPDATE_CONTRACT_BALANCE,
    contracts: data
  };
}

function addPhoneAddress(data) {
  return {
    type: ADD_PH_ADR,
    user: {
      phone: data.phone,
      address: data.address
    }
  };
}

function addPersonalPhone(data) {
  return {
    type: ADD_P_PH,
    user: {
      phone: data.phone,
      contractNumber: data.contractNumber
    }
  };
}

function addCellPhone(data) {
  return {
    type: ADD_C_PH,
    user: {
      phone: data.phone,
      contractNumber: data.contractNumber
    }
  };
}

function addPersonalEmail(data) {
  return {
    type: ADD_P_EM,
    user: {
      email: data.email,
      contractNumber: data.contractNumber
    }
  };
}

function addBeneficiaries(data) {
  return {
    type: ADD_BENFICIARIES,
    user: {
      beneficiaries: data.beneficiaries
    }
  };
}

function addBills(data) {
  return {
    type: ADD_BILLS,
    user: {
      bills: data.bills,
      index: data.index
    }
  };
}

function clearUser() {
  localStorage.removeItem("ECCO_IND_AUTH");
  return {
    type: CLEAR_USER,
    user: {}
  };
}

function clearContracts() {
  return {
    type: CLEAR_CONTRACTS,
    user: {
      contracts: []
    }
  };
}

function clearBeneficiaries() {
  return {
    type: CLEAR_BENFICIARIES,
    user: {
      beneficiaries: []
    }
  };
}

function clearBills(data) {
  return {
    type: CLEAR_BILLS,
    user: {
      index: data
    }
  };
}

function updateExpireSession(expireSession) {
  return {
    type: UPDATE_EXPIRE_SESSION,
    user: {
      expireSession: expireSession
    }
  }
}

function setContractBalance(number,balance) {
  return {
    type: SET_CONTRACT_BALANCE,
    payload: {
      number: number,
      balance: balance
    }
  }
}

function updateEmailUser(email) {
  return {
    type: UPDATE_EMAIL_USER,
    user: {
      email: email
    }
  }
}

export {
  addMainData,
  addContracts,
  updateContractsBalance,
  addPhoneAddress,
  addBeneficiaries,
  addBills,
  clearUser,
  clearContracts,
  clearBills,
  clearBeneficiaries,
  updateExpireSession,
  setContractBalance,
  updateEmailUser,
  addPersonalPhone,
  addCellPhone,
  addPersonalEmail
};
